import { get, post, put, del } from '../../../../../api/api';

// Teams
export const getTeams = () => get('/api/capacity/teams');
export const getTeam = (id) => get(`/api/capacity/teams/${id}`);
export const createTeam = (data) => post('/api/capacity/teams', data);
export const updateTeam = (id, data) => put(`/api/capacity/teams/${id}`, data);
export const deleteTeam = (id) => del(`/api/capacity/teams/${id}`);

// Team members
export const addMembers = (teamId, data) => post(`/api/capacity/teams/${teamId}/members`, data);
export const archiveMember = (teamId, memberId) =>
  fetch(`${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'}/api/capacity/teams/${teamId}/members/${memberId}/archive`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
  }).then((r) => r.json());
export const setMemberType = (teamId, memberId, type) =>
  fetch(`${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'}/api/capacity/teams/${teamId}/members/${memberId}/type`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ member_type: type }),
  }).then((r) => r.json());
export const removeMember = (teamId, memberId) => del(`/api/capacity/teams/${teamId}/members/${memberId}`);

// Sprints
export const getSprints = (teamId) => get(`/api/capacity/teams/${teamId}/sprints`);
export const getSprint = (teamId, sprintId) => get(`/api/capacity/teams/${teamId}/sprints/${sprintId}`);
export const createSprint = (teamId, data) => post(`/api/capacity/teams/${teamId}/sprints`, data);
export const updateSprint = (teamId, sprintId, data) => put(`/api/capacity/teams/${teamId}/sprints/${sprintId}`, data);
export const deleteSprint = (teamId, sprintId) => del(`/api/capacity/teams/${teamId}/sprints/${sprintId}`);

// Velocity
export const getVelocity = (teamId) => get(`/api/capacity/teams/${teamId}/velocity`);

// Proxy helpers
export const getRosterMembers = () => get('/api/capacity/roster-members');
export const getOutcomesList = () => get('/api/capacity/outcomes');
export const getApplicationsList = () => get('/api/capacity/applications');
